import React, { useState } from 'react';
import { updateModule } from '../lib/apiClient';

const ModuleMetaModal = ({ module, onClose, onSaved }) => {
  const [title, setTitle] = useState(module.title || '');
  const [description, setDescription] = useState(module.description || '');
  const [status, setStatus] = useState(module.status || 'draft');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const handleSave = async () => {
    if (!title.trim()) { setError('Title is required'); return; }
    setSaving(true); setError('');
    try {
      await updateModule(module.id, {
        title,
        description,
        status,
        order: module.order || 0,
      });
      onSaved();
    } catch (err) {
      setError(err.response?.data?.detail || 'Save failed');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" data-testid="module-meta-modal">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg">
        <div className="flex items-center justify-between p-5 border-b border-gray-200">
          <h3 className="text-xl font-bold text-gray-900">Module settings</h3>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-800 text-2xl leading-none">×</button>
        </div>
        <div className="p-6 space-y-4">
          {error && (
            <div className="p-3 bg-red-50 border border-red-200 rounded text-red-700 text-sm">{error}</div>
          )}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1">Module title</label>
            <input className="input-field" value={title} onChange={(e) => setTitle(e.target.value)}
                   data-testid="module-meta-title-input" />
          </div>
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1">Short description</label>
            <div className="text-xs text-gray-500 mb-1">
              1–2 sentences shown on the module card. Plain text only.
            </div>
            <textarea rows={3} className="input-field" value={description}
                      onChange={(e) => setDescription(e.target.value)}
                      placeholder="e.g., Introduces AI/ML concepts, terminology, and opportunities in healthcare analytics."
                      data-testid="module-meta-description-input" />
          </div>
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1">Publish status</label>
            <select className="input-field" value={status} onChange={(e) => setStatus(e.target.value)}
                    data-testid="module-meta-status-select">
              <option value="draft">Draft (Coming Soon for students)</option>
              <option value="published">Published (Visible to students)</option>
            </select>
          </div>
        </div>
        <div className="flex justify-end gap-2 p-5 border-t border-gray-200">
          <button onClick={onClose} className="btn-outline">Cancel</button>
          <button onClick={handleSave} disabled={saving} className="btn-primary"
                  data-testid="module-meta-save-btn">
            {saving ? 'Saving…' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModuleMetaModal;
